import styled from "styled-components";
import { theme } from "../../styles/styles";

export const PlanCard = styled("section")`
  max-width: 420px;
  margin-top: 2rem;
  padding: 2rem;
  border-radius: 16px;
  border: 1px solid rgba(255, 90, 60, 0.45);
  background: radial-gradient(
      ellipse at 100% 0%,
      rgba(255, 90, 60, 0.2),
      transparent 60%
    ),
    ${theme.surface};
`;

export const PlanName = styled("div")`
  display: inline-block;
  padding: 0.2rem 0.75rem;
  border-radius: 999px;
  background: ${theme.accent};
  color: #fff;
  font-family: "Motiva Sans Bold", sans-serif;
  font-size: 13px;
  letter-spacing: 0.15em;
`;

export const PlanPrice = styled("div")`
  margin: 1rem 0 1.5rem;
  font-family: "Motiva Sans Bold", sans-serif;
  font-size: 44px;
  color: ${theme.heading};

  span {
    font-family: "Motiva Sans Light", sans-serif;
    font-size: 16px;
    color: ${theme.textMuted};
    margin-left: 0.25rem;
  }
`;

export const PerkList = styled("ul")`
  list-style: none;
  margin: 0;
  padding: 0;

  li {
    position: relative;
    padding: 0.5rem 0 0.5rem 1.75rem;
    font-size: 16px;
    color: ${theme.text};
    border-top: 1px solid ${theme.border};

    &::before {
      content: "✓";
      position: absolute;
      left: 0;
      color: ${theme.accent};
      font-weight: 700;
    }
  }
`;
